/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CustomError from '../errors/CustomError';
import { urlParamsToObject } from '../oidc/util/urlParams';
export class EmailVerifyCallbackError extends CustomError {
    constructor(state, otp) {
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
export function isEmailVerifyCallbackError(error) {
    return (error.name === 'EmailVerifyCallbackError');
}
// Check if state && otp have been passed back in the url
export function isEmailVerifyCallback(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
// Parse state and otp from a urlPath (should be either a search or fragment from the URL)
export function parseEmailVerifyCallback(urlPath) {
    return urlParamsToObject(urlPath);
}
export function handleEmailVerifyCallback(authClient, search) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isEmailVerifyCallback(search)) {
            const { state, otp } = parseEmailVerifyCallback(search);
            if (authClient.idx.canProceed({ state })) {
                // same browser / device
                return yield authClient.idx.proceed({ state, otp });
            }
            else {
                // different browser or device
                throw new EmailVerifyCallbackError(state, otp);
            }
        }
    });
}
